import { UntypedFormGroup } from '@angular/forms';
import { Links, versions } from '../../project-manager/models/attachments.model';

export class AddUserType {
    organisationId: string;
    Name: string;
    Description: string;
}

export class UpdateUserType {
    SecurityRoleId: string;
    organisationId: string;
    Name: string;
    Description: string;
    Active: boolean; //this for delete UserType
}

export interface ActivityPack {
    activityPackTaggedItemId: string;
    activityPackTypeId: string;
    activityPackType: string;
    activityPackTypeSchemaVersionId: string;
    activityPackTypeLatestSchemaVersionId: string;
    activityPackTypeIcon: string;
    activityPackStatusId: string;
    activityPackStatus: string;
    activityPackTaggedItemActivityId: string;
    activityPackTaggedItemActivitySchemaVersionId: string;
    activityPackTaggedItemActivityLatestSchemaVersionId: string;
    startDate: string;
    endDate: string;
    severity: string;
    activityPackId: string;
    index: number;
    namePrimary: string;
    activityPackStatusIndex: string;
}

export interface PlantList {
    schemaVersionId: string;
    latestSchemaVersionId: string;
    lineNumberFormatUpdatePending?: boolean;
    taggedItemTypeId: string;
    taggedItemType: string;
    connectorParentId?: string;
    connectorChildId?: string;
    connectorEditedDate?: Date;
    childCount?: number;
    isParent?: boolean;
    hasMultipleParent?: boolean;
    taggedItemId: string;
    index?: number;
    namePrimary?: string;
    nameSecondary?: string;
    isFavourite?: boolean;
    editedDate?: Date;
    canAllocate?: boolean;
    activityPacks?: ActivityPack[];
    warningType?: number; //0-None,1-Critical,2-Warning,3-Information
    schemaVersion: SchemaVersion;
}

export interface ConnectorChild {
    connectorParentId: string;
    connectorId: string;
    taggedItemTypeId: string;
    taggedItemType: string;
    schemaVersionId: string;
}

export interface TaggedItemType {
    taggedItemTypeId: string;
    name: string;
}

export interface ConnectorParent {
    connectorChildId: string;
    connectorParentId: string;
    taggedItemId: string;
    editedDate: Date;
}
export interface JointData {
    jointRow: PlantList;
    IsJointEnabled: boolean;
}
export enum UploadType {
    None,
    Image,
    Load,
    Drawing,
    Attachment,
    Test,
    Certificate,
    Assessment,
    LogBook,
    Miscellaneous,
    Icon,
}

export enum Product {
    None,
    ICE,
    Management,
    iDMS,
    cDMS,
}

export enum UploadFileType {
    None,
    Profile,
    Photo,
    Source,
    Markup,
    Log,
    Assessment,
    Observation,
    Test,
    SharedContent,
    ActivityPackType,
    Email,
}

export enum BlobAccessLevel {
    Private,
    Public,
}

export interface BlobPathForCreationDto {
    product: Product;
    uploadType: UploadType;
    uploadFileType: UploadFileType;
    organisationID: string | null;
    instanceID: string | null;
    typeID: string | null;
}
export interface TaggedItemData {
    schemaVersion: SchemaVersion;
    dataContent: string;
    taggedItemId: string;
    index: number;
    namePrimary: string;
    nameSecondary: string;
    isFavourite: boolean;
    editedDate: Date;
}

export interface SchemaVersion {
    schemaVersionId: string;
    version: number;
    changeReason: string;
    editedDate: Date;
    schema: string;
    latestSchemaVersionId: string;
}
export interface ImageDatas {
    isPublic: boolean;
    accountName: string;
    containerName: string;
    content: string;
    contentType: string;
    host: string;
    hostNameType: string;
    path: string;
    port: string;
    scheme: string;
}

export interface SaveTaggedItemData {
    schemsForm: UntypedFormGroup;
    images?: any;
    CalculationResult?: any;
    TaggedItemData?: PlantList;
    ImageUrl?: string;
    NamePrimaryKey?: string;
    NameSecondaryKey?: string;
    GroupType?: string;
    imageKey: string;
    selectedConnectorChild?: ConnectorChild;
    taggedItemType?: string;
    schemaVersionId?: string;
    PageType?: string;
    dateTypeKey: any[];
    Tab?: number;
    IsImageChanged?: boolean;
    IsSave?: boolean;
    AdditionalInfo?: any;
    userList?: any;
    userSelectKey?: string[];
    lineNumberFormatId?: string;
    pipeSpecVersionId?: string;
}

export class AllowedItemChange {
    allowed: boolean;
    itemIds: string[];
}

export class PlantRow {
    Show: boolean;
    SelectedData: PlantList;
    selectedChildSecond: PlantList;
    selectedList?: PlantList[];
    active?: boolean;
    level?: number;
    name?: string;
    isEdit?: boolean;
    constructor() {
        this.Show = false;
        this.SelectedData = null;
        this.selectedChildSecond = null;
        this.selectedList = null;
        this.active = false;
        this.level = null;
        this.name = null;
        this.isEdit = false;
    }
}

export class BreadcrumbData {
    id: string;
    name: string;
    layer?: number;
    TypeName?: number;
    AdjustedName?: string;
    selectedData?: PlantList;
}
export class AvailableParents {
    connectorParentId: string;
    taggedItemId: string;
    namePrimary: string;
    taggedItemTypeId: string;
    taggedItemType: string;
}
export interface SaveLeakOrException {
    schemsForm: UntypedFormGroup;
    images?: any;
    TaggedItemData?: PlantList;
    ImageUrl?: string;
    NamePrimaryKey?: string;
    NameSecondaryKey?: string;
    GroupType?: string;
    imageKey: string;
    taggedItemType?: string;
    schemaVersionId?: string;
    PageType?: string;
}
export interface DocumentDetails {
    documentType: string;
    createdDate: string;
    documentVersionId: string;
    countTaggedItem: number;
    countActivityPack: number;
    hasFile: boolean;
    documentId: string;
    index: number;
    name: string;
    number: string;
    revision: string;
    comments: string;
    isFavourite: boolean;
    editedDate: string;
    version?: number;
    allowChildrenInherit: boolean;
}
export interface Documents {
    documentId: string;
    index: number;
    name: string;
    number: string;
    revision: string;
    comments: string;
    allowChildrenInherit?: boolean;
    isFavourite: boolean;
    editedDate: string;
    versions?: versions[];
    links?: Links[];
    blob?: Blob;
    viewId?: string;
    filename?: string;
    content?: string;
    contentType?: string;
    view?: string;
    countTaggedItem?: number;
    countActivityPack?: number;
}
export interface DocumentList {
    documents?: DocumentDetails[];
    total?: number;
}

export class DocumentLink {
    documentLinkId?: string;
    documentId?: string;
    entityId: string;
    entityType: number | string;
    active?: string;
    name?: string;
    type?: string;
}

export interface ActivityWorkpack {
    projectId: string;
    project: string;
    activityPackId: string;
    activityPack: string;
    activityPackTypeId: string;
    activityPackType: string;
    taggedItems: ActivityPackTaggedItem[];
}

export interface ActivityPackTaggedItem {
    activityPackTaggedItemId: string;
    taggedItemId: string;
    editedDate: string;
    namePrimary: string;
    taggedItemIndex: number;
    taggedItemTypeId: string;
    taggedItemType: string;
    activityPackTaggedItemStatusId: string;
    activityPackTaggedItemActivityStatus: string;
    activityPackTaggedItemActivityStatusColour: string;
    canDelete: boolean;
}

export interface SelectedPlantListData {
    selecteddata: PlantList;
    selectedList: PlantList[];
}
